import { uploadFileToServer } from '@/api/checkout'
import { IUploadImageServerRequest } from '@/interfaces/checkout'
import { generateImagePath, getAndSetHostIdFromLocalStorage } from '@/utils'
import moment from 'moment'
import Vue from 'vue'
import Vuex, { GetterTree, MutationTree, ActionTree } from 'vuex'
import store from '.'
Vue.use(Vuex)

interface State {
  log: any[];
  imagePath: string;
  server: string | null;
}

const getDefaultState = (): State => {
  return {
    log: [],
    imagePath: '',
    server: null
  }
}
const state = getDefaultState()

const getters: GetterTree<State, any> = {

}

const mutations: MutationTree<State> = {
  INITIALIZE_LOG (state: State) {
    const logStr = localStorage.getItem('eco/log')
    if (logStr) {
      try {
        state.log = JSON.parse(logStr)
      } catch (error) {
        console.error(error)
        state.log = []
      }
    } else {
      state.log = []
    }
  },
  PUSH_LOG (state: State, payload: any) {
    state.log.push({ timestamp: moment().toISOString(true), message: payload })
    localStorage.setItem('eco/log', JSON.stringify(state.log))
  },
  RESET (state: State) {
    localStorage.removeItem('eco/log')
    state = getDefaultState()
  },
  SET_IMAGE_PATH (state: State, imagePath) {
    state.imagePath = imagePath
  },
  SET_SERVER (state: State, server) {
    state.server = server
  }
}

const actions: ActionTree<State, any> = {
  async UPLOAD_LOG ({ commit, state }, payload) {
    if (payload.token && payload.token.length > 0 && state.log.length > 0) {
      let path = ''
      let destDir = ''
      if (payload.isOrderUpload) {
        // Already has set image path
        if (state.imagePath.length !== 0) {
          path = state.imagePath
        } else {
          const prefix = store.getters['webview/platform']
          path = generateImagePath(prefix)
        }
        destDir = `ToPrint/${path}`
      } else {
        path = getAndSetHostIdFromLocalStorage()
        destDir = `eco/${path}`
      }
      const blob = new Blob([JSON.stringify(state.log)], { type: 'image/jpeg' })
      const formattedDate = moment().format('YYMMDDHHmmssSSS')
      const requestBody = {
        token: payload.token,
        app_index: 6,
        destDir,
        login: 'illuxtech',
        pwd: '1234',
        file: blob
      } as IUploadImageServerRequest
      const fileName = `log-${formattedDate}.txt`
      const { data } = await uploadFileToServer(requestBody, fileName, state.server)
      if (data[0].flag === 0 && process.env.NODE_ENV === 'production') {
        commit('RESET')
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
